
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import AuthModule from "@/store/modules/core/auth.module";
import { authenticate } from "@/services/api/authenticate.service";
import { AppBarRoutes } from "@/models/utils/appBarRoutes.interface";
import StorageCartModule from "@/store/modules/storage/storageCart.module";
const storageModule = getModule(StorageCartModule, store);
const authModule = getModule(AuthModule, store);
@Component
export default class AppBar extends Vue {
  @Prop({ required: false, default: 0 }) private numberSelected: number;
  @Prop({ required: false, default: false }) private isOrderDetails: boolean;
  public numberSelectedTotal = 0;
  public dialog = false;
  public search = "";
  public hover = false;
  public visibleSearchBar = false;
  public filterModal = false;
  public isLoading = false;
  public items = [];
  public notificationsNumber = 324;

  private avatars: { id: number; name: string; action?: unknown }[] = [
    {
      id: 0,
      name: "Logout",
      action: () => {
        this.logout();
      },
    },
  ];

  public appBarRoutes: AppBarRoutes[] = [
    //  { label: "NewsHome", route: "/newshome" },
    //  { label: "Prodotti", route: "/productsservices" },
    //  { label: "Contatti", route: "/contacts" },
    //  { label: "News", route: "/news" },
    //  { label: "Magazzino", route: "/storage" },
    //  { label: "Gestione Utenti", route: "/password" },
    //  { label: "Categorie", route: "/categories" },
    //  { label: "Ricarico Cataloghi", route: "/catalogsreload" },
    //  { label: "Ordini", route: "/orders" },
  ];

  public created(): void {
    this.setRoute();
  }

  public mounted(): void {
    this.numberSelectedTotal = storageModule.count;
  }

  public updated(): void {
    this.numberSelectedTotal = storageModule.count;
  }

  @Watch("numberSelected")
  public numberSelectedChanged(): void {
    this.numberSelectedTotal = storageModule.count;
  }

  get isLoggedIn(): boolean {
    return authModule.token;
  }

  get currentRoute(): string {
    return this.$router.currentRoute.path;
  }
  get fullName(): string {
    return authModule.userName;
  }

  get email(): string {
    return authModule.userEmail;
  }

  get userInitial(): string {
    if (this.fullName) {
      let names: string[] = this.fullName.split(" ");
      names = names.map((name) => {
        return name.charAt(0);
      });

      if (names.length === 0) {
        return "UN";
      } else {
        return names[0] + names[names.length - 1];
      }
    }

    return "";
  }

  public showApp(): void {
    if (this.dialog) this.dialog = false;

    this.dialog = true;
  }

  public hideApp(): void {
    this.dialog = false;
  }

  public drawerChange(): void {
    this.$emit("drawerChange");
  }

  public searchBarAction(): void {
    //   console.warn("nothing here")
  }

  public setVisibilitySearchBar(): void {
    if (this.visibleSearchBar) this.visibleSearchBar = false;
    else this.visibleSearchBar = true;
  }

  public openFilterModal(): void {
    if (this.filterModal) this.filterModal = false;
    this.filterModal = true;
  }

  public hideFilters(): void {
    this.filterModal = false;
  }

  private hasHomeRoute(): boolean {
    const routes = this.$router.getRoutes();
    const hasHome = routes.map((route) => {
      if (route.path === "/home") {
        return true;
      }

      return false;
    });

    if (hasHome.includes(true) && this.$route.path !== "/home") {
      return true;
    }

    return false;
  }

  private goToHome(): void {
    if (this.hasHomeRoute() && this.$route.path !== "/home") {
      window.location.href = "http://bracchiruote.it";
    }
  }

  private async logout(): Promise<void> {
    await authenticate.logout();
    this.$router.push({ name: "Logout" });
  }

  private setRoute(): void {
    this.appBarRoutes = [];
    if (authModule.token && authModule.role != null) {
      //
      if (authModule.role == "0") {
        //admin
        this.appBarRoutes = [
          // {
          //   label: "Home",
          //   route: "/home",
          //   icon: "mdi-home",
          //   subElements: [],
          // },
          {
            label: "Magazzino",
            route: "/storage",
            icon: "mdi-cart",
            subElements: [],
          },
          {
            label: "Utenti",
            route: "/password",
            icon: "mdi-account-lock",
            subElements: [],
          },
          {
            label: "Categorie",
            route: "/categories",
            icon: "mdi-view-list",
            subElements: [],
          },
          {
            label: "Ricarico cataloghi",
            route: "/catalogsreload",
            icon: "mdi-book",
            subElements: [],
          },
          {
            label: "Agg. cataloghi",
            route: "/catalogsupdate",
            icon: "mdi-book",
            subElements: [],
          },
          {
            label: "Ordini",
            route: "/orders",
            icon: "mdi-archive-outline",
            subElements: [],
          },
          // {
          //   label: "Monitora prezzi",
          //   route: "/prezzi",
          //   icon: "mdi-archive-outline",
          //   subElements: [],
          // },
          {
            label: "Check prezzi",
            route: "/priceCheck",
            icon: "mdi-archive-outline",
            subElements: [],
          },
        ];
      }
      if (authModule.role == "1") {
        //costumer
        this.appBarRoutes = [
          {
            label: "Torna al sito",
            route: "/home",
            icon: "mdi-home",
            subElements: [],
          },
          // subElements: [
          //   {
          //     label: "Home",
          //     route: "/home",
          //     icon: "mdi-home",
          //     subElements: [],
          //   },
          //   {
          //     label: "News",
          //     route: "/newshome",
          //     icon: "mdi-newspaper-variant-multiple-outline",
          //     subElements: [],
          //   },
          //   {
          //     label: "Prodotti",
          //     route: "/productsservices",
          //     icon: "mdi-book-open-page-variant",
          //     subElements: [],
          //   },
          //   {
          //     label: "Chi siamo",
          //     route: "/history",
          //     icon: "mdi-information",
          //     subElements: [],
          //   },
          //   {
          //     label: "Contatti",
          //     route: "/contacts",
          //     icon: "mdi-phone",
          //     subElements: [],
          //   },
          // ],
          {
            label: "Magazzino",
            route: "/storage",
            icon: "mdi-cart",
            subElements: [],
          },
          {
            label: "Gestione utente",
            route: "/password",
            icon: "mdi-account-lock",
            subElements: [],
          },
          {
            label: "Storico ordini",
            route: "/orders",
            icon: "mdi-archive-outline",
            subElements: [],
          },
        ];
      }
    } else {
      this.appBarRoutes = [
        { label: "Home", route: "/home", icon: "mdi-home", subElements: [] },
        {
          label: "News",
          route: "/newshome",
          icon: "mdi-newspaper-variant-multiple-outline",
          subElements: [],
        },
        {
          label: "Chi siamo",
          route: "/history",
          icon: "mdi-information",
          subElements: [],
        },
        {
          label: "Prodotti",
          route: "/productsservices",
          icon: "mdi-book-open-page-variant",
          subElements: [],
        },
        {
          label: "Contatti",
          route: "/contacts",
          icon: "mdi-phone",
          subElements: [],
        },
        {
          label: "Magazzino online",
          route: "/storage",
          icon: "mdi-cart",
          subElements: [],
        },
      ];
    }
  }
}
